<template>
  <div style="position: relative;height: 100%;">
    <div class="submit-comment-wrap">
      <van-search
        ref="replyinput"
        placeholder="说点儿什么吧！"
        show-action
        @search="submitComment()"
        @focus="hidshow=false"
        @blur="hidshow=true"
        v-model="commentContens"
        class="submit-comment-form"
      >
        <div slot="action" @click="submitComment"></div>
      </van-search>
      <span class="btn-submit-comment" @click="submitComment">发布</span>
    </div>
    <div class="comment-list-wrap">
      <div v-if="commentList.length==0 && (!loading)" style="text-align: center;">
        <!--<van-tag plain type="success">暂无评论</van-tag>-->
      </div>
      <van-list
        v-model="loading"
        :finished="commentFinished"
        @load="onLoadComment"
        loading-text="正在加载..."
        :offset="300"
      >
        <van-cell v-for="item in commentList" :key="item.id" class="comment-cell">
          <div v-if="item.userId!=11532">
            <img class="profile-photo" :src="getProfilePhoto(item)">
            <span class="profile-name">{{item.userName}}</span>
          </div>
          <div v-if="item.userId==11532">
            <img class="profile-photo" :src="getProfilePhoto(item)">
            <span class="profile-name highlight">{{item.userName}}</span>
          </div>
          <div class="comment-contents">
            <span>{{item.commentContent}}</span>
          </div>
          <div>
            <span class="create-time">{{item.dateAndTimeStr}}</span>
            <span class="btn-reply" @click="reply()">回复</span>
          </div>
        </van-cell>
      </van-list>
      <div
        v-show="commentListGoneVisible"
        class="list-gone van-list__loading-text"
        style="margin-bottom: 70px;"
      >我可是有底线的！</div>
    </div>
  </div>
</template>

<script>
import { Tabbar, TabbarItem, CellGroup } from "vant";
import { NavBar, Tab, Tabs, Search, Button, Field, Popup, Tag } from "vant";
import qs from "qs";
import { List, Cell } from "vant";
import { Row, Col } from "vant";
import { Loading } from "vant";
import request from "@/utils/request";
import { Toast, Dialog, Icon } from "vant";
import moment from "moment";

export default {
  name: "Comments",
  components: {
    "van-search": Search,
    "van-icon": Icon,
    "van-field": Field,
    "van-button": Button,
    "van-list": List,
    "van-cell": Cell,
    "van-tag": Tag,
    "van-col": Col,
    "van-row": Row,
    "van-loading": Loading
  },
  data() {
    return {
      newsType: 0,
      newsZid: 0,
      activeColor: "#222633",
      lastLoadTime: 0,
      //鲜料
      newComponentsShow: false,
      titleHeight: "55px",
      navIconHeight: "0",
      newClass: {
        activeHeight: "0",
        articleHeight: "0"
      },

      //-评论=============================================================
      commentTotal: 0,
      commentList: [],
      commentVisible: false,
      commentListGoneVisible: false,
      newsId: 0, //当前评论对应新闻ID
      commentContens: "",
      commentListQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      newsType: 201,
      loading: false,
      commentFinished: false,
      commentY: "translateY(-100%)",
      lastLoadTime: 0,
      //-评论 end =========================================================

      /* 文章 */
      iframeHeight: "0",
      conentsLoading: true,
      /* 新料快报 */
      list: [],
      loading: false,
      finished: false,
      newsBaoClass: {
        newbaoListHeight: "212px"
      },
      articleSrc: ""
    };
  },
  props: {
    contentsId: String
  },
  mounted() {
    if (this.$route.query.newsid) {
      this.newsId = this.$route.query.newsid
      this.onLoadComment()
    }
  },
  created() {},
  methods: {
    //-评论=============================================================

    getProfilePhoto(item) {
      var id = parseInt(item.id % 10);
      //parseInt(Math.random()*(max-min+1)+min,10);
      var name = 5;
      if (item.userId == 11532) {
        name = 1;
      } else if (!id || id == 0) {
        //name = parseInt(Math.random()*(5-2+1)+1,10);
        name = 2;
      } else if (id > 0 && id <= 3) {
        name = 2;
      } else if (id > 3 && id <= 5) {
        name = 3;
      } else if (id > 5 && id <= 7) {
        name = 4;
      } else if (id > 7 && id <= 10) {
        name = 5;
      }

      var photo = "static/img/comments/profile-photo/" + name + ".png";
      return photo;
    },
    //点击评论按钮
    loadComment(newsId) {
      console.log("加载评论");
      this.c("loadComment", "加载评论");
      let vm = this;
      this.newsId = newsId;
      this.commentListQuery.pageIndex = 1;
      this.commentList = [];
      setTimeout(function() {
        vm.getComment(newsId);
      }, 300);
    },
    //发布评论
    submitComment() {
      if (this.commentContens == null || this.commentContens == "") {
        Dialog.alert({
          message: "请填写评论内容"
        }).then(() => {
          // on close
        });
        return;
      }
      Toast.loading({
        mask: true,
        duration: 0,
        message: "正在发布..."
      });
      let vm = this;
      let data = { newsId: this.newsId, commentContens: this.commentContens };
      //if(userName!='' && contents!=''){
      //data.commentContens =  data.commentContens + "　@"+userName+"："+contents
      //}
      data = qs.stringify(data);
      request
        .post(
          this.HOST + "/Action/NewsCommentAction.aspx?action=createComments",
          data
        )
        .then(function(res) {
          Toast.clear();
          if (res.data.state == 1) {
            let comments = {
              id: parseInt(Math.random() * (10 - 1 + 1) + 1, 10),
              userName: "热心网友",
              commentContent: vm.commentContens,
              dateAndTimeStr: moment().format("YYYY-MM-DD HH:mm:ss")
            };
            vm.commentList.unshift(comments);
            vm.commentContens = "";
            Toast("发表成功，感谢参与");
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(function(response) {
          Toast.clear();
          Toast("网络连接失败，请重试。");
          console.log(response);
        });
    },
    //回复评论
    reply() {
      this.$refs[
        "replyinput"
      ].$el.children[0].children[1].children[0].children[0].focus();
      this.$refs[
        "replyinput"
      ].$el.children[0].children[1].children[0].children[0].select();
    },
    //显示评论窗口
    displayComment() {
      this.commentVisible = true;
      //清空数据
      this.commentListQuery.pageIndex = 1;
      this.commentListGoneVisible = false;
      this.commentList = [];
      this.loading = true;
      let vm = this;
      setTimeout(function() {
        vm.commentY = "translateY(0)";
        vm.commentFinished = false;
      }, 50);
    },
    //关闭评论窗口
    closeComment() {
      this.commentFinished = true;
      this.commentY = "translateY(-100%)";
      let vm = this;
      setTimeout(function() {
        vm.commentVisible = false;
      }, 400);
    },
    //获取评论数据
    getComment(newsId) {
      let vm = this;
      //Toast('正在加载...');//return;
      let data = this.commentListQuery;
      data.newsId = newsId;
      data = qs.stringify(data);
      request
        .post(
          this.HOST + "/Action/NewsCommentAction.aspx?action=getComments",
          data
        )
        .then(function(res) {
          vm.loading = false;
          if (res.data.state == 1) {
            console.log(res.data);
            for (var i = 0; i < res.data.list.length; i++) {
              try {
                res.data.list.userName = "热心网友";
                vm.commentList.push(res.data.list[i]);
              } catch (e) {}
            }
            if (
              res.data.list.length <= 0 &&
              vm.commentListQuery.pageIndex > 1
            ) {
              vm.commentFinished = true;
              if (vm.commentList.length > 0) {
                vm.commentListGoneVisible = true;
              }
            } else {
              vm.commentListQuery.pageIndex++;
            }
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(function(response) {
          console.log(response);
        });
    },
    //加载评论数据
    onLoadComment() {
      if (!this.commentFinished) {
        this.getComment(this.newsId);
      }
    }
    //-评论 end ==========================================================
  }
};
</script>
<style scoped>
.list-gone {
  width: 100%;
  text-align: center;
  line-height: 55px;
  height: 55px;
  padding-bottom: 3%;
}

/* 评论 */

.comments-total {
  position: fixed;
  top: 10%;
  right: 7%;
  z-index: 2;
  color: #fff;
  font-size: 15px;
  font-weight: normal;
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
  text-align: center;
  box-sizing: border-box;
  padding: 0 6px;
  min-width: 28px;
  line-height: 28px;
  border-radius: 16px;
  background-color: rgba(0, 145, 67, 0.8);
}
.comment-components {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 4;
  height: calc(100% - 1.37rem);
  background-color: #ffffff;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  -webkit-transition: transform 400ms;
  transition: transform 400ms;
  transition-timing-function: ease;
  -webkit-transition-timing-function: ease;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}
.submit-comment-wrap {
  background-color: #e8e9eb;
}
.submit-comment-form {
  height: 85px;
}
.btn-submit-comment {
  position: absolute;
  top: 34.5%;
  right: 4.5%;
  font-size: 18px;
  color: #8a8a8a;
}

.comment-list-wrap {
  position: relative;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  margin-top: 84px;
}
.profile-photo {
  width: 15%;
  max-width: 48px;
  vertical-align: middle;
}
.profile-name {
  vertical-align: middle;
  margin-left: 10px;
  color: #089141;
}
.highlight {
  font-weight: bold;
  color: #e50014;
}
.comment-contents {
  padding: 10px 0;
  color: #232635;
  font-size: 15px;
}
.create-time {
  color: #7c7c7c;
}
.btn-reply {
  float: right;
  color: #089141;
  padding: 5px 17px;
  margin-right: -17px;
}

@media (max-width: 320px) {
  .btn-submit-comment {
    position: absolute;
    top: 38%;
    right: 4%;
    font-size: 15px;
  }
}
.comment-msg {
  text-align: center;
}
/* 评论 end*/
</style>
<style>
/* 评论 */
.submit-comment-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
}
.submit-comment-wrap .van-icon-search {
  display: none;
}
.submit-comment-wrap .van-field__control {
  width: 100%;
  height: 38px;
  text-align: center;
  font-size: 15px;
  padding-right: 0;
}
.submit-comment-wrap .van-search .van-cell {
  -webkit-box-flex: none;
  -ms-flex: none;
  flex: none;
  border-radius: 25px;
  padding: 0;
  width: 83%;
  border: 1px solid #999999;
}
.submit-comment-wrap .van-search .van-field__icon {
  right: 5%;
}

.submit-comment-wrap .van-search .van-icon-clear {
  right: 5%;
}

.submit-comment-wrap .comment-cell::after {
  left: 15px !important;
  right: 0 !important;
  width: auto !important;
  -webkit-transform: scale(1, 0.5) !important;
  transform: scale(1, 0.5) !important;
  border-color: #b8b8b8 !important;
  border-bottom-width: 1px !important;
}
/* 评论Confirm弹窗 */
.submit-comment-wrap .van-dialog__message {
  text-align: center;
}

.submit-comment-wrap .van-tabbar-item__icon {
  width: 100%;
  height: 31.64%;
  display: inline;
  text-align: center;
}
.submit-comment-wrap .van-tabbar-item__icon img {
  height: 100%;
  width: auto !important;
  margin: auto;
}

/* 评论 end*/
</style>


// WEBPACK FOOTER //
// src/components/comments.vue